import YU_COLOURS from "../../../../styles/colours";
import React from "react";
export var DownArrow = function (_a) {
    var className = _a.className, title = _a.title, _b = _a.fill, fill = _b === void 0 ? YU_COLOURS.B1100 : _b, width = _a.width, height = _a.height;
    return (React.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        title && React.createElement("title", null, title),
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M10 0a1 1 0 0 1 1 1v15.59l3.3-3.3a1 1 0 0 1 1.51 1.32l-.11.1-5 5a1 1 0 0 1-1.4 0l-5-5a1 1 0 0 1 .1-1.41 1 1 0 0 1 1.3 0L9 16.6V1a1 1 0 0 1 1-1Z", fill: fill, fillRule: "evenodd" })));
};
